export function downloadFile(url: string): void {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
        if (xhr.status === 200) {
            const blob = new Blob([xhr.response], { type: xhr.getResponseHeader("content-type")! });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            const fileName = url.substring(url.lastIndexOf("/") + 1);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error(`Failed to download file from ${url}. Status code: ${xhr.status}`);
        }
    };
    xhr.send();
}
